import Grid from '@mui/material/Grid2';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import CardHeader from '@mui/material/CardHeader';
import SvgIcon from '@mui/material/SvgIcon';
import CardContent from '@mui/material/CardContent';
import { ElementType, FC } from 'react';
import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { TIntegrationCard } from '../../type';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';
import { payrollActions } from '../../../../store/payroll/slice';
import { getSelectedIntegration } from '../../../../store/payroll/selectors';

const IntegrationCard: FC<TIntegrationCard> = ({ integration }) => {
  const dispatch = useAppDispatch();
  const selectedIntegration = useAppSelector(getSelectedIntegration);
  const theme = useTheme();
  const { t } = useTranslation('payroll');

  const onClick = () => {
    dispatch(payrollActions.setSelectedIntegration({
      ...integration,
      icon: '',
    }));
  };

  return (
    <Grid size={{
      lg: 4,
      md: 6,
      xs: 12,
      sm: 6,
    }}
    >
      <Box onClick={onClick}>
        <Card sx={{
          height: 270,
          position: 'relative',
          border: selectedIntegration.id === integration.id ? `1px solid ${theme.palette.primary.main}` : '',
        }}
        >
          <CardHeader
            sx={{
              p: 2,
            }}
            title={integration.title}
            action={(
              <Box display="flex" alignItems="center">
                {integration.isSvgIcon
                  ? (
                    <SvgIcon
                      fontSize="large"
                      component={integration.icon as ElementType}
                      inheritViewBox
                    />
                  ) : (
                    <img
                      src={integration.icon as string}
                      height={40}
                      alt="appLogo"
                    />
                  )}
              </Box>
        )}
          />
          <Divider sx={{ borderStyle: 'dashed' }} />
          <CardContent>
            <Typography variant="body2">{t(`${integration.description}`)}</Typography>
          </CardContent>
        </Card>
      </Box>
    </Grid>

  );
};

export {
  IntegrationCard,
};
